<template>
    <li class="dropdown">
        <a href="javascript:;" class="dropdown-toggle" @click.prevent="$emit('toggle', {isOpen: !isOpen})">
            {{ lang }}
        </a>
        <transition name="fade">
            <ul v-show="isOpen" class="dropdown-menu dropdown-menu-default lang">
                <li :class="{active: lang === 'fr'}">
                    <a href="#" @click.prevent="switchLocale('fr')">
                        FR
                    </a>
                </li>
                <li :class="{active: lang === 'en'}">
                    <a href="#" @click.prevent="switchLocale('en')">
                        EN
                    </a>
                </li>
            </ul>
        </transition>
    </li>
</template>

<script>
  import * as localeMutations from '@/app/store/modules/locale/mutation-types'

  export default {
    props: {
      isOpen: {
        default: false
      }
    },
    computed: {
      lang () {
        return this.$store.state.locale.current
      }
    },
    methods: {
      switchLocale (locale) {
        if (locale !== this.lang) {
          this.$store.commit(`locale/${localeMutations.SET_LOCALE}`, locale)
          const route = Object.assign({}, this.$route)
          route.params.locale = locale
          this.$router.push(route)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .dropdown-toggle {
        padding: 16px 10px 13px !important;
        text-transform: uppercase;
        font-weight: 300;
        color: #c6cfda;

        &:hover, &.focus {
            color: #c6cfda;
        }
    }

    .dropdown-menu.lang {
        width: auto !important;
        min-width: 72px !important;
        max-width: none !important;

        li {
            a {
                text-align: center;
            }

            &.active {
                background: #eee;

                a {
                    text-decoration: none !important;

                    &:hover, &:focus {
                        background: transparent !important;
                        text-decoration: none !important;
                        cursor: default !important;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/components/header/LangSwitcher.vue